import sleep from 'sleep-promise';
import request from 'axios';
import { isEmptyObject } from './validators/formValidators';
import { getClientAuthHeader,
         clearClientToken } from '../client/token';

import { browserHistory } from 'react-router';
import _ from 'lodash';

export const promiseMiddleware = () => {
    return (next) => (async function(action) {
        let { promise, poll, types, ...rest } = action;
        if (!promise && !poll) {
            return next(action);
        }

        const [REQUEST, SUCCESS, FAILURE, ARGS] = types;
        next({ ...rest, type: REQUEST, args: ARGS });
        while (true) {
            try {
                // TODO: Replace poll with longJob below for fax.
                if (poll) {
                    promise = request.get(poll, getClientAuthHeader());
                }

                let result = await promise;
                if (poll && (!result.data.pollFinished)) {
                    next({ ...rest, result, type: SUCCESS });
                    await sleep(process.env.CLIENT_POLLING_INTERVAL_MILISECONDS);
                    continue;
                }

                if (result.data.longJob) {
                    while (!result.data.pollFinished) {
                        const id = result.data.id;
                        await sleep(result.data.pollIntervalMs || process.env.CLIENT_POLLING_INTERVAL_MILISECONDS);
                        result = await request.get(`/api/v1/job_result/${encodeURIComponent(id)}`, getClientAuthHeader());
                        console.log('Polling: ' + JSON.stringify(result.data, null, 2));
                    }

                    if (result.data.error) {
                        const errorStatus = result.data.errorCode || 500;
                        const error = {data: result.data.error, errorStatus};
                        throw error;
                    }

                    result.data = result.data.result;
                }

                next({ ...rest, result, type: SUCCESS });
                return result;

            } catch (error) {
                let errorStr;
                let errorStatus;
                if (error) {
                    errorStr = error.data;
                    errorStatus = error.status;
                }

                let extractError = (value) => {
                    if (_.isObject(value) && !_.isString(value)) {
                        return JSON.stringify(value);

                    } else {
                        return value;
                    }
                };

                if (error instanceof Error) {
                    //debugger;
                    console.error(new Error().stack, error);
                    if (error.response) {
                        errorStr = extractError(error.response.data);
                        if (error.response.data && error.response.data.message) {
                            errorStr = extractError(error.response.data.message);
                        }

                        errorStatus = error.response.status;

                    } else if (error.message) {
                        errorStr = extractError(error.message);
                        errorStatus = error.status;
                    }
                }

                if (!errorStr || isEmptyObject(errorStr)) {
                    errorStr = 'Unknown error happened, please contact Customer Support:\n';
                    errorStr += JSON.stringify(error, null, 4);
                }

                if (errorStatus == 401) {
                    console.error('User access denied error.');
                    clearClientToken();
                    browserHistory.push('/user/login');
                    next({...rest, error: errorStr, errorStatus: errorStatus, type: 'USER_LOG_OUT'});
                    return;
                }

                next({...rest, error: errorStr, errorStatus: errorStatus, type: FAILURE});
                console.error('Promise middleware error:');
                console.error(errorStr);
                throw errorStr;
            }
        }
    });
};